import React from "react";
import fondoFlujo from "../../assets/image/stella/fondo-flujo-tv.png";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import Buy from "../../widgets/buy";

export default function Plans() {
    return (
        <section className="relative" id="planes">
            <div
                style={{
                    backgroundImage: `linear-gradient(180deg,#00000085,#141414), url(${fondoFlujo})`
                }}
                className="absolute inset-0 bg-no-repeat bg-center bg-cover opacity-50 -z-10"></div>
            <div className="container py-4 md:py-20 text-center">
                <div className="p-4 md:p-12"><h2
                    className="uppercase text-3xl md:text-[34px] leading-[38px] font-bold">Planes Stella TV | Comprar
                    Cuenta</h2>
                    <div className="mt-5 text-white">Abajo tiene los <strong>precios de Stella TV 2025</strong>, puede seleccionar
                        el que desee y realizar el pago. <span className="text-active">Recuerde que sus datos de acceso se mandarán por correo electrónico</span>. <span
                            className="underline">Contamos con pagos 100% seguros y rápidos.</span></div>
                    <ul className="mt-11 grid md:grid-cols-4 gap-5 px-2.5">
                        <li className="border-[5px] border-primari rounded-[30px] flex flex-col items-center overflow-hidden  intersect:animate-in slide-in-from-bottom intersect-once duration-1250">
                            <div className="bg-lineald w-full">
                                <div className=" text-white">
                                    <h3 className="pt-3 w-full text-2xl leading-[34px]  font-semibold">PLAN ANUAL</h3>
                                    <div className="text-sm">12 + 2 MESES (regalo extra)</div>
                                    <div className="h-[17px]">&nbsp;</div>
                                </div>
                            </div>

                            <div className="bg-backgrounds w-full flex flex-col items-center">
                                <div
                                    className="mt-[15px] mb-3 flex items-start gap-[3px] text-7xl text-primari leading-none font-bold">
                                    <span className="text-[.3em]">$</span>
                                    <div>
                                        <div className="leading-[0.8]">86</div>
                                        <div className="text-sm leading-[1.6em]">12 + <span
                                            className="text-[#ff0000] font-bold">2 MESES</span></div>
                                    </div>
                                    <span className="text-[.3em]">99</span></div>
                                <ul className="w-full px-4 text-left list-none">
                                    <li className="px-4">
                                        <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className="w-6 h-6 text-primari cursor-pointer"
                                            />
                                            <span>+90 canales de deportes</span></div>
                                        <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                    </li>
                                    <li className="px-4">
                                        <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className="w-6 h-6 text-primari cursor-pointer"
                                            />
                                            <span>Ver en <span
                                                className="text-[#ff0000] font-bold">4 Pantallas</span></span></div>
                                        <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                    </li>
                                    <li className="px-4">
                                        <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className="w-6 h-6 text-primari cursor-pointer"
                                            />
                                            <span>Películas, Series, Animes</span></div>
                                        <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                    </li>
                                    <li className="px-4">
                                        <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className="w-6 h-6 text-primari cursor-pointer"
                                            />
                                            <span>Contenido Kids</span></div>
                                        <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                    </li>
                                    <li className="px-4">
                                        <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className="w-6 h-6 text-primari cursor-pointer"
                                            />
                                            <span>Contenido +18 Adultos</span></div>
                                        <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                    </li>
                                    <li className="px-4">
                                        <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                            <FontAwesomeIcon
                                                icon={faCheck}
                                                className="w-6 h-6 text-primari cursor-pointer"
                                            />
                                            <span>Compatible con Android</span></div>
                                    </li>
                                </ul>
                                <div className="py-[30px] text-white">
                                    <Buy/>
                                    <div className="mt-[15px] text-[13px] leading-[18px] font-light">* Compra
                                        Segura
                                    </div>
                                </div>
                            </div>
                        </li>
                        <li className="border-[5px] border-primari rounded-[30px] flex flex-col items-center overflow-hidden intersect:animate-in slide-in-from-right intersect-once duration-1250">
                            <h3 className="pt-3 w-full text-2xl leading-[34px] font-semibold">1 MES</h3>
                            <div className="text-sm leading-[17px] text-[#F0BF10] mb-4">mensual</div>
                            <div
                                className="mt-[15px] mb-3 flex items-start gap-[3px] text-7xl text-primari leading-none font-bold">
                                <span className="text-[.3em]">$</span>
                                <div>
                                    <div className="leading-[0.8]">8</div>
                                    <div className="text-sm leading-[1.6em]">1 MES</div>
                                </div>
                                <span className="text-[.3em]">0</span></div>
                            <ul className="w-full px-4 text-left list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>+90 canales de deportes</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Ver en <span>3 Pantallas</span></span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Películas, Series, Animes</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Contenido Kids</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Contenido +18 Adultos</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Compatible con Android</span></div>
                                </li>
                            </ul>
                            <div className="py-[30px] text-white">
                                <Buy/>
                                <div className="mt-[15px] text-[13px] leading-[18px] font-light">* Compra
                                    Segura
                                </div>
                            </div>
                        </li>
                        <li className="border-[5px] border-primari rounded-[30px] flex flex-col items-center overflow-hidden intersect:animate-in slide-in-from-left intersect-once duration-1250">
                            <h3 className="pt-3 w-full text-2xl leading-[34px] font-semibold">3 MESES</h3>
                            <div className="text-sm leading-[17px] text-[#F0BF10] mb-4">trimestral</div>
                            <div
                                className="mt-[15px] mb-3 flex items-start gap-[3px] text-7xl text-primari leading-none font-bold">
                                <span className="text-[.3em]">$</span>
                                <div>
                                    <div className="leading-[0.8]">23</div>
                                    <div className="text-sm leading-[1.6em]">3 MESES</div>
                                </div>
                                <span className="text-[.3em]">99</span></div>
                            <ul className="w-full px-4 text-left list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>+90 canales de deportes</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Ver en <span>3 Pantallas</span></span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Películas, Series, Animes</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Contenido Kids</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Contenido +18 Adultos</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Compatible con Android</span></div>
                                </li>
                            </ul>
                            <div className="py-[30px] text-white">
                                <Buy/>
                                <div className="mt-[15px] text-[13px] leading-[18px] font-light">* Compra
                                    Segura
                                </div>
                            </div>
                        </li>
                        <li className="border-[5px] border-primari rounded-[30px] flex flex-col items-center overflow-hidden intersect:animate-in slide-in-from-left intersect-once duration-1250">
                            <h3 className="pt-3 w-full text-2xl leading-[34px] font-semibold">PLAN SEMESTRAL</h3>
                            <div className="text-sm leading-[17px] text-[#F0BF10] mb-4">6 + 1
                                MESES (regalo extra)
                            </div>
                            <div
                                className="mt-[15px] mb-3 flex items-start gap-[3px] text-7xl text-primari leading-none font-bold">
                                <span className="text-[.3em]">$</span>
                                <div>
                                    <div className="leading-[0.8]">48</div>
                                    <div className="text-sm leading-[1.6em]">6 +  <span
                                        className="text-[#ff0000] font-bold">1 MESES</span></div>
                                </div>
                                <span className="text-[.3em]">99</span></div>
                            <ul className="w-full px-4 text-left list-none">
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>+90 canales de deportes</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Ver en <span
                                            className="text-[#ff0000] font-bold">4 Pantallas</span></span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Películas, Series, Animes</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Contenido Kids</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Contenido +18 Adultos</span></div>
                                    <div className="my-2.5 mx-[12.5%] border-t border-[#54595F]"></div>
                                </li>
                                <li className="px-4">
                                    <div className="flex items-center gap-3 text-[13px] text-[#B4B4B4]">
                                        <FontAwesomeIcon
                                            icon={faCheck}
                                            className="w-6 h-6 text-primari cursor-pointer"
                                        />
                                        <span>Compatible con Android</span></div>
                                </li>
                            </ul>
                            <div className="py-[30px] text-white">
                                <Buy/>
                                <div className="mt-[15px] text-[13px] leading-[18px] font-light">* Compra
                                    Segura
                                </div>
                            </div>
                        </li>
                    </ul>

                </div>
            </div>
        </section>
    );
}
